class GroupingFields {
    order: number = 1;
    fields: KnockoutObservableArray<ReportField> = ko.observableArray([]);

    constructor(data?: any, isOriginalTemplate: boolean = false) {
        if (!data) {
            return;
        }

        this.order = data.order ?? 1;
        if (data.fields) {
            this.fields(createInstancesWithParameter(ReportField, data.fields, isOriginalTemplate));
        }
    }
}